import type { ReactNode } from 'react';

import type { FactTile } from '@/lib/types';
import { mergeClassNames } from '@/lib/utils';
import { FactTileInfo } from './fact-tiles';

// `boxOnPhone` turns the pill into a box for a two-column grid on a phone. A
// lone box spans both columns; only-of-type, so a pill wrapped in a div beside
// it never counts. The slim side padding keeps "18 classes/quarter" on one line
// at 16px from a 375px phone and at 15px on a narrower one; larger text wraps,
// so the heights are minimums.
export const FactPill = ({
  boxOnPhone = false,
  children,
}: {
  boxOnPhone?: boolean;
  children: ReactNode;
}) => (
  <span
    className={mergeClassNames(
      'inline-flex min-h-9 items-center rounded-full bg-gray-100 px-3.5 py-1.5 text-sm font-medium text-gray-900 [overflow-wrap:anywhere]',
      boxOnPhone &&
        'max-sm:min-h-16 max-sm:justify-center max-sm:rounded-xl max-sm:px-2 max-sm:text-center max-sm:text-base max-sm:font-semibold max-sm:only-of-type:col-span-2 max-[374px]:text-[15px]'
    )}
  >
    {children}
  </span>
);

// From sm one tile alone across the card reads as an empty band, so a page
// with a single fact shows it among the pills; on a phone it stays a tile.
export const LoneFactPill = ({ tile }: { tile: FactTile }) => (
  <div className="hidden sm:contents">
    <FactPill>
      {tile.lead}
      {tile.prefix}
      {tile.value}
      {tile.tail}
      <FactTileInfo tile={tile} />
    </FactPill>
  </div>
);
